import { render, staticRenderFns } from "./fixed-svg.vue?vue&type=template&id=6f776d2f&scoped=true"
import script from "./fixed-svg.vue?vue&type=script&lang=js"
export * from "./fixed-svg.vue?vue&type=script&lang=js"
import style0 from "./fixed-svg.vue?vue&type=style&index=0&id=6f776d2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f776d2f",
  null
  
)

export default component.exports